import React from 'react';
type IndustryBackdropProps = {
  tone?: 'light' | 'dark';
};
const TERMS = ['GLOBAL SOURCING', 'SOURCE TO PAY', 'CATEGORY STRATEGY', 'SUPPLIER GOVERNANCE', 'SPEND ANALYTICS', 'CONTRACT CONTROLS', 'VENDOR MANAGEMENT', 'ACQUISITION INTEGRATION', 'PRIVATE EQUITY', 'RISK AND COMPLIANCE', 'DIGITAL PROCUREMENT', 'WORKING CAPITAL'];
export function IndustryBackdrop({
  tone = 'light'
}: IndustryBackdropProps) {
  const rows = Array.from({
    length: 9
  });
  const textColor = tone === 'dark' ? 'text-white/[0.06]' : 'text-ink/[0.05]';
  return <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-31" data-mp="1yahlvdvzkscz">
      <div className={tone === 'dark' ? 'absolute inset-0 industry-grid-light' : 'absolute inset-0 industry-grid'} data-id="element-32" data-mp="1tava78vt3k6a" />
      <div className="absolute inset-0 flex flex-col justify-between py-6" data-id="element-33" data-mp="1kcjjz7yuqoed">
        {rows.map((_, rowIndex) => <div key={rowIndex} className={`whitespace-nowrap text-[2.1rem] leading-none tracking-wider2 ${textColor}`} style={{
        transform: `translateX(-${rowIndex % 4 * 9}%)`
      }} data-id="element-34" data-mp="1fcwzcdgp25vj" data-mpi={rowIndex}>
            {TERMS.concat(TERMS).slice(rowIndex % TERMS.length, rowIndex % TERMS.length + 8).join('   ·   ')}
          </div>)}
      </div>
    </div>;
}